import React from 'react';
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import {
  Tree,
  TreeNode,
} from 'react-organizational-chart';
import PropTypes from 'prop-types';
import { Alert } from '@material-ui/lab';
import EstadoChip from 'components/estadoChip/EstadoChip';

const styles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
});

const Card = ({
  node = {},
}) => {
  const {
    username: nombre = '',
    estado_suscripcion: cargo = '',
    color = '#ffffff',
  } = node;

  const useStyles = makeStyles({
    menuContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    card: {
      margin: '0px 10px',
      paddingTop: 0,
      display: 'flex',
      justifyContent: 'center',
    },
    cardBody: {
      textAlign: 'center',
      padding: 10,
      background: color,
      width: 300,
      borderRadius: 16,
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      transition: 'box-shadow 0.2s ease-in-out',
      '&:hover': {
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
      },
    },
    icon: {
      width: 15,
      height: 15,
    },
    name: {
      color: '#393939',
    },
    text: {
      color: '#444444',
    },
    ul: {
      listStyle: 'none',
      fontSize: 10,
      textAlign: 'center',
    },
    listItem: {
      cursor: 'pointer',
      padding: 10,
      borderBottom: '1px solid #C4C4C4',
      transition: 'box-shadow 0.2s ease-in-out, background 0.2s ease-in-out',
      '&:hover': {
        background: '#C4C4C4',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
      },
      popover: {
        boxShadow: '0 4px 40px rgba(0, 0, 0, 0.2)',
      },
    },
    alert: {
      width: '100%',
      margin: '10px 0px',
    },
  });
  const classes = useStyles();

  return (
    <>
      <div className={classes.card}>
        <div
          className={classes.cardBody}
        >
          <Typography
            variant="h3"
            className={classes.text}
          >
            {nombre}
          </Typography>
          <Typography
            className={classes.text}
            variant="body1"
          >
            <EstadoChip estado={cargo} />
          </Typography>
        </div>
      </div>
    </>
  );
};

const renderTree = (nodes, principal, functions) => (
  principal ? (
    nodes.map((item) => (
      <Tree
        label={<Card node={item} functions={functions} />}
      >
        {Array.isArray(item.referidos)
          ? item.referidos.map((node) => renderTree(node, false, functions))
          : null}
      </Tree>
    ))
  ) : (
    <TreeNode
      label={<Card node={nodes.referido} functions={functions} />}
    >
      {Array.isArray(nodes.referido?.referidos)
        ? nodes.referido?.referidos.map((node) => renderTree(node, false, functions))
        : null}
    </TreeNode>
  )
);

function OrganizationalTree({
  data = [],
  onEdit,
  onCreate,
  onDelete,
}) {
  const classes = styles();
  return (
    <>
      <div className={classes.container}>
        {data.length === 0 ? (
          <Alert
            className={classes.alert}
            variant="outlined"
            severity="warning"
          >
            No hay datos para mostrar...
          </Alert>
        ) : (
          renderTree(data, true, {
            onEdit,
            onCreate,
            onDelete,
          })
        )}
      </div>
    </>
  );
}

OrganizationalTree.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.array,
  ]),
  onEdit: PropTypes.func,
  onCreate: PropTypes.func,
  onDelete: PropTypes.func,
};

export default OrganizationalTree;
